import { CSS_VARS } from '../constants';
import type { StageSettingsT } from '../types';
export function applySettingsToDom(stageEl: HTMLDivElement | null, settings: StageSettingsT): void {
  if (!stageEl) return;
  const {
    scale,
    rotation,
    x,
    y
  } = settings;
  stageEl.style.setProperty('transform', `matrix(${scale}, 0, 0, ${scale}, ${x}, ${y}) rotate(${rotation}deg)`);
  stageEl.style.setProperty(CSS_VARS.SCALE, String(scale));
  stageEl.style.setProperty(CSS_VARS.ROTATION, `${rotation}deg`);
  stageEl.style.setProperty(CSS_VARS.VISIBLE_SCALE, String(1 / scale));
  stageEl.style.setProperty(CSS_VARS.INVERSE_SCALE_1X, `${2 / scale}px`);
  stageEl.style.setProperty(CSS_VARS.INVERSE_SCALE_1_5X, `${3 / scale}px`);
}